'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { FileText, Compass, Star } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

export default function Slide16LongTerm({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0f2318]">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1660910755114-0d04b2fe4036"
          alt="Cảnh thiên nhiên hồ xanh bình yên nhìn từ trên cao, du lịch xanh Việt Nam"
          className="w-full h-full object-cover opacity-10" />

        <div className="absolute inset-0 bg-gradient-to-tl from-[#1a3a2a]/50 via-[#0f2318]/90 to-[#0f2318]" />
        <div className="absolute top-1/2 right-0 w-[400px] h-[400px] rounded-full bg-[rgba(168,216,122,0.04)] blur-3xl" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-24 pt-28 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-4">
          <div className="chapter-badge">Quyền lợi sinh viên</div>
        </div>

        <div className="fade-in-up mb-3">
          <h2 className="font-display font-800 text-[clamp(28px,4.5vw,56px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            Quyền lợi dành cho sinh viên
          </h2>
        </div>

        <div className="fade-in-up mb-10">
          <div className="section-divider" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 fade-in-up">
          {[
          {
            icon: <FileText size={28} className="text-[#4caf7d]" />,
            title: 'Có thêm điểm cộng cho hồ sơ cá nhân',
            desc: 'Chương trình có đủ yếu tố trải nghiệm, cộng đồng, truyền thông và kỹ năng nên rất phù hợp để sinh viên đưa vào CV, hồ sơ cá nhân, portfolio, hồ sơ học bổng hoặc hồ sơ ứng tuyển thực tập – việc làm.',
            color: '#4caf7d'
          },
          {
            icon: <Compass size={28} className="text-[#e8a030]" />,
            title: 'Có cơ hội tiếp cận định hướng nghề nghiệp sau đại học',
            desc: 'Sinh viên tham gia chương trình có thêm cơ hội được kết nối với những định hướng phát triển dài hơn sau khi tốt nghiệp. Đây có thể là bước mở đầu để các bạn tiếp cận môi trường làm việc thực tế, mở rộng mối quan hệ và gia tăng cơ hội nghề nghiệp trong tương lai.',
            color: '#e8a030'
          },
          {
            icon: <Star size={28} className="text-[#a8d87a]" />,
            title: 'Có cơ hội được đào tạo trở thành đại sứ thương hiệu lâu dài',
            desc: 'Những sinh viên có tinh thần tích cực, hình ảnh phù hợp và khả năng truyền thông tốt có thể được lựa chọn để tiếp tục đồng hành cùng Tri An Green Travel trong vai trò đại sứ thương hiệu sinh viên. Đây là cơ hội để các bạn phát triển thêm kỹ năng đại diện hình ảnh, kết nối cộng đồng, tham gia sự kiện và xây dựng dấu ấn cá nhân rõ ràng hơn.',
            color: '#a8d87a'
          }].
          map((card, i) =>
          <div
            key={`longterm-${i}`}
            className="rounded-2xl p-7 flex flex-col"
            style={{
              background: `linear-gradient(145deg, ${card.color}12 0%, ${card.color}04 100%)`,
              border: `1px solid ${card.color}25`
            }}>

              <div
              className="p-3 rounded-xl inline-flex mb-5 w-fit"
              style={{ background: `${card.color}18` }}>

                {card.icon}
              </div>
              <h3 className="font-display font-700 text-[17px] lg:text-[18px] text-[#f0ede6] mb-4 leading-snug">{card.title}</h3>
              <p className="font-body text-[13px] lg:text-[14px] text-[#a0b8a8] leading-relaxed flex-1">{card.desc}</p>
            </div>
          )}
        </div>

        {/* "Nhận được nhiều hơn một chuyến đi" banner */}
        <div className="fade-in-up mt-8 rounded-2xl p-6 lg:p-8" style={{ background: 'linear-gradient(135deg, #1a4a2a 0%, #0f3020 100%)', border: '1px solid rgba(76,175,125,0.3)' }}>
          <h3 className="font-display font-700 text-[18px] lg:text-[20px] text-[#f0ede6] mb-3">
            Nhận được nhiều hơn một chuyến đi
          </h3>
          <p className="font-body text-[14px] lg:text-[15px] text-[#a0b8a8] leading-relaxed">
            Điều sinh viên mang về sau chương trình không chỉ là một trải nghiệm miễn phí, mà còn là một hành trình đáng nhớ, một chứng nhận có giá trị, một bộ hình ảnh đẹp, một câu chuyện để kể lại và cảm giác mình đã thật sự làm được một điều có ích.
          </p>
        </div>
      </div>
    </SlideWrapper>);

}